import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section id="pricing" className="w-full bg-white pb-24" data-id="element-64" data-mp="3ucnhe1n67xy9">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-65" data-mp="3uei15cmphk0r">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="rounded-3xl bg-ink px-6 py-16 text-center sm:px-12 sm:py-20" data-id="element-66" data-mp="c7tuvjfx6qti">
          <span className="inline-flex items-center rounded-full bg-white/10 px-4 py-1.5 text-sm font-medium text-white/80" data-id="element-67" data-mp="h4u3a108s5ns">
            One-time payment · $27
          </span>
          <h2 className="mx-auto mt-6 max-w-2xl text-3xl font-extrabold tracking-tight text-white sm:text-5xl" data-id="element-68" data-mp="qvx0ustyq2ib">
            Live in alignment today.
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-lg text-white/70" data-id="element-69" data-mp="14tdbyhn7ekge">
            Everything you need to start using Notion as your GPS Journal.
          </p>
          <a href="#top" className="mt-9 inline-flex rounded-full bg-white px-8 py-4 text-base font-semibold text-ink transition-transform hover:scale-[1.03]" data-id="element-70" data-mp="2c5pys0lj7m4t">
            Get GPS Journal
          </a>
        </motion.div>
      </div>
    </section>;
}